// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 914 ? "4540edbe" : chunkId) + "." + {"137":"f454d409d7c9904f","914":"f4255b265bdfce35"}[chunkId] + ".js";
};